import * as Cesium from "cesium";

export const checkCartesianIfZero = (cartesian: Cesium.Cartesian3 | undefined) => {
	if (!cartesian) return true;
	return cartesian.x === 0 && cartesian.y === 0 && cartesian.z === 0;
};
